export default __webpack_public_path__ + "static/10-11b7216d12f06a281e485bebf90d9420.jpg";